export type WhatsAppComposePayload = {
  templateId?: string;
  templateBody?: string;
  templateVariables?: Record<string, string>;
  freeformBody?: string;
};

export function interpolateTemplateBody(
  body: string,
  variables: Record<string, string>,
) {
  return body.replace(/\{\{([^}]+)\}\}/g, (_, key: string) => {
    const trimmed = key.trim();
    return variables[trimmed] ?? '';
  });
}

export function buildDefaultTemplateVariables(
  labels: Array<{ index: string; label: string }>,
  recipientName?: string,
) {
  const firstName = recipientName?.trim().split(/\s+/)[0] || '';
  const values: Record<string, string> = {};

  labels.forEach((variable) => {
    const normalizedLabel = variable.label.toLowerCase();
    const normalizedIndex = variable.index.toLowerCase();

    if (
      normalizedIndex === '1' ||
      normalizedLabel.includes('first name') ||
      normalizedLabel === 'name' ||
      normalizedIndex === 'name'
    ) {
      values[variable.index] = firstName;
      return;
    }

    if (
      normalizedLabel.includes('college') ||
      normalizedLabel.includes('company') ||
      normalizedIndex === '2'
    ) {
      values[variable.index] = 'Cosmetic College';
    }
  });

  return values;
}
